import { render, staticRenderFns } from "./commonInput.vue?vue&type=template&id=1af5f296"
import script from "./commonInput.vue?vue&type=script&lang=js"
export * from "./commonInput.vue?vue&type=script&lang=js"
import style0 from "./commonInput.vue?vue&type=style&index=0&id=1af5f296&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports